import React, { Component } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import logo from "./img/logo.png";
import footerData from "./data/footer-data";
import {
  Wrapper,
  Inner,
  Top,
  TopColumn,
  Logo,
  Contact,
  ContactTitle,
  ContactNumber,
  LinksTitle,
  Link,
  TrustPilot,
  Middle,
  Social,
  IconLink,
  MiddleLinks,
  MiddleLink,
  Bottom,
  BottomText,
} from "./styles/footer-styles";

class Footer extends Component {
  state = {};

  render() {
    const { top, middle, bottom } = footerData;
    const { contact, links } = top;
    const { positionTop, positionAbsolute } = this.props;
    const year = new Date(Date.now()).getFullYear();
    const isIe = detect().name === "ie";
    const browser = detect().name;

    return (
      <Wrapper
        className="fadeInUp animated"
        data-test-id="footer"
        positionTop={positionTop}
        browser={browser}
        positionAbsolute={positionAbsolute}
      >
        <Top>
          <Inner isIe={isIe}>
            <TopColumn flex={3}>
              <Logo src={logo} alt="Logo" />
              <Contact>
                <ContactTitle>{contact.contactTitle}</ContactTitle>
                <ContactNumber>{contact.phone1}</ContactNumber>
              </Contact>
            </TopColumn>
            <TopColumn flex={2}>
              <LinksTitle>{links.column1.linksTitle}</LinksTitle>
              <Link
                href={links.column1.link1.url}
                title={links.column1.link1.label}
              >
                {links.column1.link1.label}
              </Link>
              <Link
                href={links.column1.link2.url}
                title={links.column1.link2.label}
              >
                {links.column1.link2.label}
              </Link>
              <Link
                href={links.column1.link3.url}
                title={links.column1.link3.label}
              >
                {links.column1.link3.label}
              </Link>
              <Link
                href={links.column1.link4.url}
                title={links.column1.link4.label}
              >
                {links.column1.link4.label}
              </Link>
            </TopColumn>
            <TopColumn flex={2}>
              <LinksTitle>{links.column2.linksTitle}</LinksTitle>
              <Link
                href={links.column2.link1.url}
                title={links.column2.link1.label}
              >
                {links.column2.link1.label}
              </Link>
              <Link
                href={links.column2.link2.url}
                title={links.column2.link2.label}
              >
                {links.column2.link2.label}
              </Link>
              <Link
                href={links.column2.link3.url}
                title={links.column2.link3.label}
              >
                {links.column2.link3.label}
              </Link>
            </TopColumn>
            <TopColumn flex={2}>
              <LinksTitle>{links.column3.linksTitle}</LinksTitle>
              <Link
                href={links.column3.link1.url}
                title={links.column3.link1.label}
              >
                {links.column3.link1.label}
              </Link>
              <Link
                href={links.column3.link2.url}
                title={links.column3.link2.label}
              >
                {links.column3.link2.label}
              </Link>
              <Link
                href={links.column3.link3.url}
                title={links.column3.link3.label}
              >
                {links.column3.link3.label}
              </Link>
              <Link
                href={links.column3.link4.url}
                title={links.column3.link4.label}
              >
                {links.column3.link4.label}
              </Link>
            </TopColumn>
            <TopColumn flex={2}>
              <LinksTitle noMobile />
              <Link
                href={links.column4.link1.url}
                title={links.column4.link1.label}
              >
                {links.column4.link1.label}
              </Link>
              <Link
                href={links.column4.link2.url}
                title={links.column4.link2.label}
              >
                {links.column4.link2.label}
              </Link>
            </TopColumn>
            <TopColumn flex={3}>
              <LinksTitle noMobile />
              <TrustPilot
                href="https://www.hiring-hub.com/testimonials-and-reviews"
                rel="noopener noreferrer"
              >
                <div
                  className="trustpilot-widget"
                  data-locale="en-GB"
                  data-template-id="53aa8807dec7e10d38f59f32"
                  data-businessunit-id="5808db060000ff0005964ce4"
                  data-style-height="150px"
                  data-style-width="100%"
                  data-theme="dark"
                  data-text-color="#ffffff"
                >
                  Trustpilot
                </div>
              </TrustPilot>
            </TopColumn>
          </Inner>
        </Top>
        <Middle>
          <Inner isIe={isIe}>
            <Social>
              <IconLink href={middle.social.facebook} title="Facebook">
                <FontAwesomeIcon icon={faFacebookSquare} />
              </IconLink>
              <IconLink href={middle.social.twitter} title="Twitter">
                <FontAwesomeIcon icon={faTwitterSquare} />
              </IconLink>
              <IconLink href={middle.social.linkedin} title="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </IconLink>
            </Social>
            <MiddleLinks>
              <MiddleLink
                href={middle.links.link1.url}
                title={middle.links.link1.label}
              >
                {middle.links.link1.label}
              </MiddleLink>
              <MiddleLink
                href={middle.links.link2.url}
                title={middle.links.link2.label}
              >
                {middle.links.link2.label}
              </MiddleLink>
              <MiddleLink
                href={middle.links.link3.url}
                title={middle.links.link3.label}
              >
                {middle.links.link3.label}
              </MiddleLink>
              <MiddleLink
                href={middle.links.link4.url}
                title={middle.links.link4.label}
              >
                {middle.links.link4.label}
              </MiddleLink>
            </MiddleLinks>
          </Inner>
        </Middle>
        <Bottom>
          <Inner bottom isIe={isIe}>
            <BottomText>
              © {year} {bottom.copy}
            </BottomText>
            <BottomText>{bottom.about}</BottomText>
          </Inner>
        </Bottom>
      </Wrapper>
    );
  }
}

Footer.propTypes = {
  positionTop: PropTypes.number,
  positionAbsolute: PropTypes.bool,
};

Footer.defaultProps = {
  positionTop: PropTypes.isNull,
  positionAbsolute: PropTypes.isNull,
};

export default Footer;
